import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import Spinner from "@xo-union/tk-component-spinner";
import React from "react";
import styles from "./content.css";
export var Content = function Content(_ref) {
  var _context;
  var children = _ref.children,
    loading = _ref.loading,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context = "".concat(styles.container, " ")).call(_context, className)
  }, loading ? /*#__PURE__*/React.createElement(Spinner, {
    className: styles.spinner
  }) : children);
};